module.exports = __webpack_public_path__ + "static/media/leaderboard.68d30ab9.svg";